import type { FunctionComponent, PropsWithChildren } from 'react'
import type * as React from 'react'

export interface ITableProps extends PropsWithChildren {
  type?: string
}

interface ITableComponents {
  Head: FunctionComponent<PropsWithChildren & { className?: string }>
  Body: FunctionComponent<PropsWithChildren>
  Cell: FunctionComponent<PropsWithChildren & { className?: string }>
  Row: FunctionComponent<{
    children: React.ReactElement<unknown, string | React.JSXElementConstructor<unknown>>[] | React.ReactElement<unknown, string | React.JSXElementConstructor<unknown>>
    onMouseEnter?: React.MouseEventHandler<HTMLTableRowElement>
    className?: string
  }>
  Footer: FunctionComponent<{ children: React.ReactElement<unknown, string | React.JSXElementConstructor<unknown>>[] }>
}

export const Table: FunctionComponent<ITableProps> & ITableComponents = ({ children, type = 'table-fixed' }) => {
  return (
    <div className="overflow-x-auto w-full">
      <table className={`w-full ${type} rounded-md`}>{children}</table>
    </div>
  )
}

Table.Head = function TableHead({ children, className = '' }) {
  return <thead className={className}>{children}</thead>
}

Table.Body = function TableBody({ children }) {
  return <tbody className="divide-y divide-gray-100">{children}</tbody>
}

Table.Row = function TableRow({ children, onMouseEnter, className = '' }) {
  return (
    <tr className={`cursor-pointer ${className}`} onClick={onMouseEnter}>
      {children}
    </tr>
  )
}

Table.Footer = function TableFooter({ children }) {
  return <tfoot>{children}</tfoot>
}

Table.Cell = function TableCell({ children, className = '' }) {
  return <td className={`py-2 px-3 ${className}`}>{children}</td>
}
